import { CustomerInitiative } from 'generated/maya.types';
import { CiStatus } from 'modules/maya/basics/enums/maya.enums';
import useGetAllCustomerInitiativeTypeQuery from 'modules/maya/graphql/queries/getAllCustomerInitiatives';

const useCustomerInitiativeTypeOptions = (isTemplate: boolean) => {
  const { data: customerInitiativeType } = useGetAllCustomerInitiativeTypeQuery(
    undefined,
    {
      isTemplate,
      status: [CiStatus.DRAFT, CiStatus.ACTIVE],
    },
  );
  const customerInitiativeOptions = customerInitiativeType.map((element: CustomerInitiative) => {
    return {
      id: element._id,
      label: element.title,
    };
  });

  return customerInitiativeOptions;
};

export default useCustomerInitiativeTypeOptions;

